import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ITheme, IWhatsappBotTheme} from '../types/ITheme';

const initialState: ITheme = {
    drawerOpen: false,
    infoModalOpened: false,
    viewTableList: false,
    paypalPlanOpen:false,
    installBannerEvent:null,
    whatsappBot: {
        serverConnected: false,
        activedSesion: false,
        managerModalOpened: false,
    },
    // openWsBotModal: false,
    notifSideOpened: false,

}
const slice = createSlice({
    name: 'themeSetting',
    initialState,
    reducers: {
        toggleDrawer(state) {
            state.drawerOpen = !state.drawerOpen;
        },
        toggleinfoModalOpened(state) {
            state.infoModalOpened = !state.infoModalOpened;
        },
        toggleNotifSide(state, action: PayloadAction<boolean|undefined>) {
            if (action.payload !== undefined){
                state.notifSideOpened = action.payload;
            }else{
                state.notifSideOpened = !state.notifSideOpened;
            }
        },
        setWhatsappBot(state, action: PayloadAction<IWhatsappBotTheme>) {
            state.whatsappBot = {...state.whatsappBot, ...action.payload};
        },
        // setOpenWsBotModal(state, action: PayloadAction<{ open:boolean }>) {
        //     state.openWsBotModal = action.payload.open;
        // },
        togglePaypalPlan(state) {
            state.paypalPlanOpen = !state.paypalPlanOpen;
        },
        toggleViewTable(state: ITheme) {
            state.viewTableList = !state.viewTableList;
        },
        setInstallBannerEvent(state: ITheme,action: PayloadAction<any>) {
            state.installBannerEvent = action.payload;
        }
    },

});

export const {toggleDrawer,toggleNotifSide, togglePaypalPlan,toggleViewTable,setWhatsappBot,setInstallBannerEvent, toggleinfoModalOpened} = slice.actions;
export default slice.reducer;
